"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({});
const dataSchema = zod_1.z.object({
    channelId: zod_1.z.string((0, validation_1.labelZodErrors)("Channel")).min(1, "Channel is required."),
});
exports.default = new ItemDefinition_1.ItemDefinition("SlackMessage", configSchema, dataSchema, new validation_1.ValidatorPipeline("SlackMessage Config Validator", []), new validation_1.ValidatorPipeline("SlackMessage Data Validator", []));
//# sourceMappingURL=SlackMessage.js.map